import React, { Component } from 'react';
import { connect } from 'react-redux';

class MasqueradeBanner extends Component {
  constructor() {
    super();
    this.state = { collapsed: false };
  }

  render() {
    if (this.state.collapsed || !this.state.masqueraded) return null;
    return (
      <div className="environment-banner" onClick={() => this.setState({ collapsed: true })}>
        <h2>You are masquerading as an agent</h2>
        <p>(click banner to hide)</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  masqueraded: state.currentAgent.masqueraded,
});

export default connect(mapStateToProps)(MasqueradeBanner);
